import { apiKeyClient } from "@better-auth/api-key/client";
import { adminClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  basePath: "/api/auth",
  // adminClient esta solo por el campo `role` del usuario: es lo que decide
  // que ve y que puede hacer cada cuenta en la interfaz.
  plugins: [apiKeyClient(), adminClient()],
});

export const { useSession, signIn, signOut } = authClient;

/** Espejo de src/auth/roles.ts en el backend. */
export type AppRole = "owner" | "viewer";

/**
 * Rol de la sesion actual. Cualquier valor que no reconozcamos cae en
 * `viewer`, igual que en el backend: el fallo va hacia el permiso menor.
 *
 * Esto solo decide que se pinta. Quien decide de verdad es el backend, que
 * responde 403 a las escrituras de un `viewer`.
 */
export function useRole(): AppRole {
  const { data: session } = useSession();
  const role = (session?.user as { role?: string | null } | undefined)?.role;
  return role === "owner" ? "owner" : "viewer";
}

export function useIsOwner(): boolean {
  return useRole() === "owner";
}
